<div class="modal-content border-0 rounded-0 mm-default-text">
    <div class="modal-header mm-modal-header rounded-0">
        <h6 class="modal-title" id="titleLabel">{{title}}</h6>
        <button type="button" class="btn-close btn-close-white opacity-100" aria-label="Close" (click)="dismiss()">
        </button>
    </div>
    <div class="modal-body">
        {{ message }}
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" (click)="decline()">{{ btnCancelText }}</button>
        <button type="button" class="btn btn-sm btn-primary" (click)="accept()">{{ btnOkText }}</button>
    </div>
</div>
